define("ember-cli-string-helpers/helpers/titleize", ["exports", "@ember/component/helper", "ember-cli-string-helpers/utils/titleize", "ember-cli-string-helpers/-private/create-string-helper"], function (_exports, _helper, _titleize, _createStringHelper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.titleize = _exports.default = void 0;
  const titleize = _exports.titleize = (0, _createStringHelper.default)(_titleize.default);
  var _default = _exports.default = (0, _helper.helper)(titleize);
});